"use strict";

class DefaultReadonlyController {
  constructor($scope) {
    this.$scope = $scope;
  }
}

export default DefaultReadonlyController;
